// extracted by mini-css-extract-plugin
export default {"today-day-number-circle-text":"CusFullCalendar_today-day-number-circle-text__rNh4P"};